import {createTheme} from '@material-ui/core/styles';
import purple from '@material-ui/core/colors/purple';


export const theme = createTheme({
  palette: {
    primary: {
      main: '#D2B48C',
    },
    secondary: {
      main: 'rgb(47,46,46)',
    },
  },
  typography: {
    root: {
      fontFamily: `"Fira Sans Condensed", "Helvetica", "Arial", sans-serif`,
    },
    subtitle2:{
      fontFamily: `"Fira Sans Condensed", "Helvetica", "Arial", sans-serif`,
      fontWeight:200
    }
  },
  MuiToolbar: {
    root: {
      fontFamily: `"Fira Sans Condensed", "Helvetica", "Arial", sans-serif`,
    },
    dense: {
      fontFamily: `"Fira Sans Condensed", "Helvetica", "Arial", sans-serif`,
    },
  },components: {
        MuiCssBaseline: {
          styleOverrides: `
            @font-face {
              font-family: 'Ping';
            }`
        }
  }
});
